import React from 'react'

const Blog2banner = () => {
  return (
    <>
     <section className="tf-slider blog2  parallax">
            <div className="content"></div>
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-12">
                        {/* <FormContent /> */}
                    </div>
                </div>
            </div>
            <div className="overlay"></div>
        </section>
        </>
  )
}

export default Blog2banner